import { useTranslation } from 'react-i18next';

const stats = [
  { numKey: 'stats.years', labelKey: 'stats.years.label', icon: 'ri-shield-star-line' },
  { numKey: 'stats.clients', labelKey: 'stats.clients.label', icon: 'ri-building-2-line' },
  { numKey: 'stats.projects', labelKey: 'stats.projects.label', icon: 'ri-code-s-slash-line' },
  { numKey: 'stats.support', labelKey: 'stats.support.label', icon: 'ri-customer-service-2-line' },
];

export default function StatsBar() {
  const { t } = useTranslation();

  return (
    <section className="bg-white border-y border-primary-200 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-accent/5 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-0 lg:divide-x lg:divide-primary-200">
          {stats.map((stat, i) => (
            <div key={i} className="flex flex-col items-center justify-center text-center px-6 py-2">
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className={`${stat.icon} text-primary text-2xl`} />
              </div>
              <div className="text-4xl font-heading font-bold gradient-text-primary mb-1">
                {t(stat.numKey)}
              </div>
              <div className="text-sm text-gray-500">{t(stat.labelKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
